import { create } from 'zustand';
import { CurrencyOption } from './useCurrencies';

interface Currency {
    label: string;
    code: string;
    symbol: string;
    value: string;
  }

interface CurrencySelectorStore {
    selectedCurrency: CurrencyOption | null;
    setSelectedCurrency: (currency: Currency) => void;
  }

const useCurrencyStore = create<CurrencySelectorStore>((set) => ({
    selectedCurrency: null,
    setSelectedCurrency: (currency) => set({ selectedCurrency: currency }),
  }));

export default useCurrencyStore;


